import { getSharedAudioContext } from './getSharedAudioContext'

/**
 * Короткий beep 880 Hz / 0.25 с через OscillatorNode, если mp3 недоступен.
 */
const playOscillatorBeep = (): void => {
  try {
    const context = getSharedAudioContext()

    if (!context) {
      return
    }

    const oscillator = context.createOscillator()
    const gainNode = context.createGain()

    oscillator.type = 'sine'
    oscillator.frequency.value = 880
    gainNode.gain.value = 0.3

    oscillator.connect(gainNode)
    gainNode.connect(context.destination)

    oscillator.start()
    oscillator.stop(context.currentTime + 0.25)
  } catch {
    // звук не критичен для работы админки
  }
}

/**
 * Воспроизводит звук нового заказа: сначала mp3 из public/sounds, при ошибке — Web Audio beep.
 */
export const playNewOrderSound = (): void => {
  try {
    const audio = new Audio('/sounds/new-order.mp3')
    void audio.play().catch(() => {
      playOscillatorBeep()
    })
  } catch {
    playOscillatorBeep()
  }
}
